import type { Action } from 'easy-peasy';
import { action } from 'easy-peasy';

import type { AudioPlaybackModel } from './student/audioPlayback';
import { audioPlaybackModel } from './student/audioPlayback';

export interface StudentModel {
    selectedAnswerId: string;
    selectAnswer: Action<StudentModel, string>;
    lastSubmittedExamId?: string;
    setLastSubmittedExamId: Action<StudentModel, string>;
    audioPlayback: AudioPlaybackModel;
}

const studentModel: StudentModel = {
    selectedAnswerId: '',
    selectAnswer: action((state, payload) => {
        state.selectedAnswerId = payload;
    }),
    setLastSubmittedExamId: action((state, payload) => {
        state.lastSubmittedExamId = payload;
    }),
    audioPlayback: audioPlaybackModel,
};

export default studentModel;
